'use strict'

var Marionette = require('marionette')

/**
 * Login layout
 * -----------------------------------------------------------------------------
 */
var Layout = Marionette.View.extend({
  template: require('./templates/layout.html'),
  triggers: {
    'click .js-submit': 'form:submit'
  },
  className: 'page-login',
  initialize: function () {
    document.querySelector('body').classList.add('page-login')
  },
  destroy: function () {
    document.querySelector('body').classList.remove('page-login')
  }
})
module.exports.Layout = Layout



// WEBPACK FOOTER //
// ./js/modules/page-login/show/view.js